import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Table from '@saucelabs/sl-component-tables';
import classNames from 'classnames/bind';

import { AppRecord, AppUploadingRecord } from '../records';
import MobileAppTableRow from './MobileAppTableRow';
import MobileAppUploadingTableRow from './MobileAppUploadingTableRow';
import NoticeForOldUsers from './NoticeForOldUsers';
import Styles from './MobileAppTable.styles';
import { APP_UPLOAD_STATUS } from '../constants';

const context = classNames.bind(Styles);

const COLUMN_LABELS = ['App', 'Version', 'OS', 'Last Change'];

const MobileAppTable = ({ apps, appsUploading, onClick, uploadAppCancel }) => (
  <>
    <Table
      className={context('table')}
      hover
      responsive
    >
      <thead>
        <tr className={Styles.row}>
          {COLUMN_LABELS.map((col) => (
            <th
              key={col}
              className={Styles['header-col']}
            >
              {col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className={Styles['table-body']}>
        {appsUploading
          .filter(({ status }) => (
            [APP_UPLOAD_STATUS.UPLOADING, APP_UPLOAD_STATUS.CANCELED].includes(status)
          ))
          .map((app) => (
            <MobileAppUploadingTableRow
              key={app.id}
              app={app}
              uploadAppCancel={uploadAppCancel}
            />
          ))
        }
        {apps.map((app) => (
          <MobileAppTableRow
            key={app.id}
            app={app}
            onClick={onClick}
          />
        ))}
      </tbody>
    </Table>
    <div className={Styles['notice-wrapper']}>
      <NoticeForOldUsers />
    </div>
  </>
);
MobileAppTable.propTypes = {
  apps: PropTypes.arrayOf(ImmutablePropTypes.recordOf(AppRecord)).isRequired,
  appsUploading: PropTypes.arrayOf(ImmutablePropTypes.recordOf(AppUploadingRecord)).isRequired,
  onClick: PropTypes.func.isRequired,
  uploadAppCancel: PropTypes.func.isRequired,
};
export default MobileAppTable;
